<template>
  <a
    :href="linkFixed"
    :target="isExternal || matchStorage || newWindow ? '_blank' : '_self'"
    @click="onClick"
  >
    <slot />
  </a>
</template>
<script>
export default {
  name: "KkLink",
  props: {
    link: {
      type: String,
      required: true,
    },
    router: {
      type: Object,
      default: null,
    },
    store: {
      type: Object,
      default: null,
    },
    newWindow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      home: "biennale.ru",
    };
  },
  computed: {
    matchHttp() {
      return this.link.match(/^https?:\/\/(.+)$/);
    },
    matchHome() {
      return this.link.match(new RegExp(`^https?://(www.|)${this.home}(.*)$`));
    },
    matchIp() {
      return this.link.match(
        /^https?:\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(:\d{1,5}|)(\/.*)$/
      );
    },
    isExternal() {
      return this.matchHttp && !this.matchHome && !this.matchIp;
    },
    matchStorage() {
      return this.linkFixed.startsWith("/storage");
    },
    linkFixed() {
      if (this.matchHome) {
        return this.biennaleUrl(this.matchHome[2]);
      } else if (this.matchIp) {
        return this.biennaleUrl(this.matchIp[2]);
      } else {
        return this.link;
      }
    },
  },
  methods: {
    onClick(event) {
      const router = this.router === null ? this.$router : this.router;
      if (!this.isExternal && !this.newWindow) {
        if (this.matchStorage) {
          return;
        } else {
          event.preventDefault();
          if (this.$route && this.$route.path == this.linkFixed) {
            return;
          }
          router.push({ path: this.linkFixed });
        }
      }
    },
    biennaleUrl(url) {
      const store = this.store === null ? this.$store : this.store;
      const biennaleNode =
        store.getters.getActualBiennaleIdent ||
        store.getters.getLastBiennaleIdent;
      if (url === "") return "/";
      if (!biennaleNode) return url;
      if (url.match(/^\/program\/calendar\/?$/)) {
        return `/${biennaleNode}/program/calendar`;
      } else if (url.match(/^\/program\/?$/)) {
        return `/${biennaleNode}/program`;
      } else if (url.match(/^\/participants\/?$/)) {
        return `/${biennaleNode}/participants`;
      } else if (url.match(/^\/team\/?$/)) {
        return `/${biennaleNode}/team`;
      } else if (url.match(/^\/sites\/?$/)) {
        return `/${biennaleNode}/sites`;
      } else {
        return url;
      }
    },
  },
};
</script>
